import React from 'react';
import { Link } from 'react-router-dom';

const iconClass = 'w-[22px] h-[22px] sm:w-6 sm:h-6 text-gray-900';

const SocialRailIcon: Record<string, React.ReactNode> = {
  facebook: (
    <svg className={iconClass} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12c0 5.996 4.388 10.978 10.125 11.854v-8.385H7.078V12h3.047V9.356c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874V12h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  ),
  twitter: (
    <svg className={iconClass} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
  youtube: (
    <svg className={iconClass} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  ),
  instagram: (
    <svg className={iconClass} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
    </svg>
  ),
  whatsapp: (
    <svg className={iconClass} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.881 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  ),
};

const WHATSAPP_WA_ME_URL = 'https://wa.me/923065758181';

const socialRail = [
  { id: 'facebook', href: 'https://www.facebook.com/share/1DsFXR2Aki/', label: 'Facebook', panel: 'bg-[#1877F2]' },
  { id: 'twitter', href: 'https://x.com/WaterCoole98795', label: 'X (Twitter)', panel: 'bg-[#5AC8FA]' },
  { id: 'youtube', href: 'https://www.youtube.com/@NationalelectricWatercoole-q7d', label: 'YouTube', panel: 'bg-[#FF0000]' },
  {
    id: 'instagram',
    href: 'https://www.instagram.com/national_electric_water_cooler?utm_source=qr&igsh=MTF4dnY2amNobjM4NQ==',
    label: 'Instagram',
    panel: 'bg-gradient-to-br from-[#833ab4] via-[#fd1d1d] to-[#fcb045]',
  },
  { id: 'whatsapp', href: WHATSAPP_WA_ME_URL, label: 'WhatsApp', panel: 'bg-[#25D366]' },
] as const;

const STORE_MAPS_URL = 'https://www.google.com/maps?q=31.439161,74.361298';
const BRANCH_1_MAPS_URL = 'https://www.google.com/maps?q=30.206791,71.464722';
const BRANCH_2_MAPS_URL = 'https://www.google.com/maps?q=33.624222,73.068703';

const SUPPORT_EMAIL = 'watercoolern@gmail.com';
const GMAIL_COMPOSE_URL = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(SUPPORT_EMAIL)}`;

const Footer: React.FC = () => {
  return (
    <>
      <aside
        className="fixed right-0 top-1/2 z-[90] flex -translate-y-1/2 flex-col overflow-hidden rounded-l-xl shadow-lg ring-1 ring-black/10"
        aria-label="Social media"
      >
        {socialRail.map(({ id, href, label, panel }) => (
          <a
            key={id}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex h-11 w-11 items-center justify-center transition-opacity hover:opacity-90 active:opacity-100 sm:h-12 sm:w-12 ${panel}`}
            aria-label={label}
          >
            {SocialRailIcon[id]}
          </a>
        ))}
      </aside>

    <footer className="bg-gray-900 text-white py-24 rounded-t-[4rem] px-4 overflow-hidden relative">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 relative z-10">
        {/* Branding */}
        <div className="col-span-1 md:col-span-1">
          <Link to="/" className="text-3xl font-black text-blue-600 mb-6 inline-block">
            National Industries
          </Link>
          <p className="text-gray-400 font-medium leading-relaxed max-w-xs pr-4">
            The nation's most trusted electronic store for premium cooling technology and household essentials.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-xl font-bold mb-8">Shop Collections</h4>
          <ul className="space-y-4 text-gray-400 font-medium">
            <li><Link to="/store" className="hover:text-blue-600 transition-all">Air Coolers</Link></li>
            {/* <li><Link to="/store" className="hover:text-blue-600 transition-all">Refrigerators</Link></li> */}
            <li><Link to="/store" className="hover:text-blue-600 transition-all">Smart Fans</Link></li>
            <li><Link to="/store" className="hover:text-blue-600 transition-all">Air Conditioners</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="text-xl font-bold mb-8">Quick Navigation</h4>
          <ul className="space-y-4 text-gray-400 font-medium">
            <li><Link to="/" className="hover:text-blue-600 transition-all">Home</Link></li>
            <li><Link to="/about" className="hover:text-blue-600 transition-all">About Our Story</Link></li>
            <li><Link to="/faqs" className="hover:text-blue-600 transition-all">Common FAQs</Link></li>
            <li><Link to="/donation" className="hover:text-blue-600 transition-all">Donate (Ehsaal-e-Sawab)</Link></li>
            {/* <li><Link to="/admin/login" className="hover:text-blue-600 transition-all">Staff Login</Link></li> */}
          </ul>
        </div>

        {/* Contact info */}
        <div>
          <h4 className="text-xl font-bold mb-8">Office & Support</h4>
          <ul className="space-y-4 text-gray-400 font-medium leading-relaxed pr-6">
            <li>
              <a
                href={STORE_MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex gap-3 hover:text-blue-600 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 rounded-sm"
                aria-label="Open store address in Google Maps"
              >
                <span className="text-lg shrink-0" aria-hidden>📍</span>
                <span>
                  Bank stop, Ashiyana Road, <br />
                  Lahore_kasur, Road, تحصیل ماڈل ٹاؤن, 54000, PK
                </span>
              </a>
            </li>
            <li>
              <a
                href={BRANCH_1_MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex gap-3 hover:text-blue-600 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 rounded-sm"
                aria-label="Open Branch 2 location in Google Maps"
              >
                <span className="text-lg shrink-0" aria-hidden>📍</span>
                <span>Mohalla Kotla Tollay Khan, Multan, PK </span>
              </a>
            </li>
            <li>
              <a
                href={BRANCH_2_MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex gap-3 hover:text-blue-600 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 rounded-sm"
                aria-label="Open Branch 3 location in Google Maps"
              >
                <span className="text-lg shrink-0" aria-hidden>📍</span>
                <span>Branch — Rawalpindi, Punjab, PK</span>
              </a>
            </li>
            <li>
              <a
                href="tel:+923217732994"
                className="flex gap-3 hover:text-blue-600 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 rounded-sm"
                aria-label="Call 03217732994"
              >
                <span className="text-lg shrink-0" aria-hidden>
                  📞
                </span>
                <span>03217732994-(Call)</span>
              </a>
            </li>
            <li>
              <a
                href={WHATSAPP_WA_ME_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex gap-3 hover:text-blue-600 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 rounded-sm"
                aria-label="Open WhatsApp chat for 03065758181"
              >
                <span className="text-lg shrink-0" aria-hidden>
                  📞
                </span>
                <span>03065758181-(WhatsApp)</span>
              </a>
            </li>
            <li>
              <a
                href={GMAIL_COMPOSE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex gap-3 hover:text-blue-600 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 rounded-sm break-all"
                aria-label={`Compose email to ${SUPPORT_EMAIL} in Gmail`}
              >
                <span className="text-lg shrink-0" aria-hidden>
                  ✉️
                </span>
                <span>{SUPPORT_EMAIL}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-20 pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-gray-500 font-bold text-xs uppercase tracking-widest gap-6">
        <p>&copy; 2026 Cooler Electronics Store. All rights reserved.</p>
        {/* <div className="flex gap-8">
            <span className="hover:text-white transition-all cursor-pointer">Terms Of Service</span>
            <span className="hover:text-white transition-all cursor-pointer">Privacy Policy</span>
        </div> */}
      </div>

      {/* Abstract Background Elements */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-600/5 rounded-full blur-[100px] -z-0" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-blue-600/5 rounded-full blur-[80px] -z-0" />
    </footer>
    </>
  );
};

export default Footer;
